<!-- A single fullscreen flash frame, played once on mount. -->
<div class="flash" aria-hidden="true"></div>

<style lang="postcss">
  .flash {
    position: absolute;
    animation: flash 350ms ease-out forwards;
    inset: 0;
    background: white;
    pointer-events: none;
  }
  @keyframes flash {
    from {
      opacity: 0.65;
    }
    to {
      opacity: 0;
    }
  }
  @media (prefers-reduced-motion: reduce) {
    .flash {
      display: none;
    }
  }
</style>
